import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  bottom: 100%;
  position: absolute;
  padding: 5px 0;
  width: max-content;
`;
